import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from 'axios';
// app
import { Auth as AuthEntity } from '../../../../entities/auth';
import { Message, MessageTypes } from '../../../../entities/site';
import { openSnackbar, closeSnackbar } from '../../../../store/action-creators';
import { colors } from '../../../../config/styles';
// containers
import RowContainer from '../../../../containers/Row';
import Modal from '../../../../containers/Modal';
// components
import TextInput from '../../../../components/inputs/TextInput';
import ActionButton from '../../../../components/buttons/ActionButton';
import SelectInput, { SelectItem } from '../../../../components/inputs/SelectInput';
import SearchResultItem from '../../../../components/inputs/SearchResultItem';
// services
import AuthService from '../../../../services/auth';
// entities
import { Campaign, campaignTypes, campaignClients } from '../../../../entities/site';
import { User } from '../../../../entities/user';
import { templateTypes } from '../../../../entities/notification';

const styles: any = {
  link: {
    color: colors.blue,
    cursor: 'pointer'
  },
  footer: {
    textAlign: 'center',
    fontSize: 12
  }
}

interface AddTemplateProps {
  open: any;
  auth: AuthEntity;
  templateId: string;
  onClose(route?: string): void
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface AddTemplateState {
  id: string;
  name: string;
  description: string;
  rate: number;
  client: string;
  type: string;
  category: string;
  message: Message;
  disabled: boolean;
  clients: SelectItem[];
  types: SelectItem[];
  categories: SelectItem[];
  termUser: string;
  users: User[];
  userId: string;
  termCampaign: string;
  campaigns: Campaign[];
  campaignId: string;
}

class AddTemplate extends Component<AddTemplateProps, AddTemplateState> {

  constructor(props: AddTemplateProps) {
    super(props);
    this.state = {
      id: '',
      name: '',
      description: '',
      rate: 0,
      client: '',
      type: '',
      category: '',
      message: {
        message: '',
        messageType: MessageTypes.notification
      },
      disabled: false,
      clients: campaignClients,
      types: templateTypes,
      categories: campaignTypes,
      termUser: '',
      users: [],
      userId: '',
      termCampaign: '',
      campaigns: [],
      campaignId: ''
    }
  }

  componentDidMount = () => {
    // mounted
    if (this.props.templateId) {
      this.fetchTemplate(this.props.templateId);
    }
  }

  componentDidUpdate = (prevProps: AddTemplateProps, prevState: AddTemplateState) => {
    if (prevProps.templateId !== this.props.templateId && this.props.templateId) {
      this.fetchTemplate(this.props.templateId);
    }
  }

  fetchTemplate = async (templateId: string) => {
    try {
      const templateRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/template/${templateId}`);
      this.setState({
        id: templateRes.data.id,
        name: templateRes.data.name,
        description: templateRes.data.description,
        rate: templateRes.data.rate,
        client: templateRes.data.client,
        type: templateRes.data.type,
        category: templateRes.data.category
      });
    } catch (error) {
      // error
    }
  }

  fetchUsers = async (termSearch: string) => {
    const usersRes = await axios.post(`${AuthService.getApiUrls().user}/users/_search`, {
      "query": {
        "multi_match": {
          "query": termSearch,
          "type": "phrase_prefix",
          "fields": ["name", "email"]
        }
      }
    });
    this.setState({ users: usersRes.data.results });
  }

  fetchCampaigns = async (termSearch: string) => {
    const campaignRes = await axios.post(`${AuthService.getApiUrls().site}/campaigns/_search`, {
      "query": {
        "multi_match": {
          "query": termSearch,
          "type": "phrase_prefix",
          "fields": ["name"]
        }
      }
    });
    this.setState({ campaigns: campaignRes.data.results });
  }

  onNameChange = (event: any) => {
    this.setState({ name: event.target.value });
  }

  onDescriptionChange = (event: any) => {
    this.setState({ description: event.target.value });
  }

  onClientChange = (event: any) => {
    this.setState({ client: event.target.value });
  }

  onTypeChange = (event: any) => {
    this.setState({ type: event.target.value });
  }

  onCategoryChange = (event: any) => {
    this.setState({ category: event.target.value });
  }

  onRateChange = (event: any) => {
    this.setState({ rate: event.target.value });
  }

  handleSave = () => {
    // sign up
    try {
      if (!this.checkForm()) {
        return;
      }

      this.setState({
        disabled: true
      });

      const data = {
        name: this.state.name,
        description: this.state.description,
        client: this.state.client,
        type: this.state.type,
        category: this.state.category,
        rate: this.state.rate,
        userId: this.state.userId ? this.state.userId : 'f39be04a-0fc0-49bf-86ee-25b645de6afb',
        campaignId: this.state.campaignId
      };

      const urls = AuthService.getApiUrls();

      if (this.state.id) {

        axios.put(`${urls.notifications}/message/template/${this.state.id}`, data).then(() => {
          this.props.openSnackbar('Successfully updated template');
          this.resetForm();
        }).catch(() => {
          this.setState({ disabled: false });
          this.setState({ message: { message: 'Error saving template', messageType: MessageTypes.error } });
        });

      } else {

        axios.post(`${urls.notifications}/message/template`, data).then(() => {
          this.props.openSnackbar('Successfully saved template')
          this.resetForm();
        }).catch(() => {
          this.setState({ disabled: false });
          this.setState({ message: { message: 'Error saving template', messageType: MessageTypes.error } });
        });

      }

    } catch (error) {
      this.setState({ disabled: false });
      this.setState({ message: { message: 'Error saving template', messageType: MessageTypes.error } });
    }

  }

  handleUserSearch = (searhTerm: string) => {
    this.setState({ termUser: searhTerm });
    if (searhTerm.length > 2) {
      this.fetchUsers(searhTerm);
    }
    if (searhTerm.length === 0) {
      this.setState({ users: [] });
    }
  }

  handleCampaignSearch = (searhTerm: string) => {
    this.setState({ termCampaign: searhTerm });
    if (searhTerm.length > 2) {
      this.fetchCampaigns(searhTerm);
    }
    if (searhTerm.length === 0) {
      this.setState({ campaigns: [] });
    }
  }

  resetForm = () => {
    this.setState({
      disabled: false,
      id: '',
      name: '',
      description: '',
      client: '',
      rate: 0,
      message: { message: '', messageType: MessageTypes.notification }
    });
    this.props.onClose();
  }

  checkForm = () => {
    let error = '';
    if (!this.state.name) {
      error = 'Name required';
    }
    if (!this.state.description) {
      error = 'Description required';
    }
    if (!this.state.client) {
      error = 'Client required';
    }
    if (error) {
      this.setState({ message: { message: error, messageType: MessageTypes.error } });
      return false;
    }
    return true;
  }

  handleAddUser = (id: string, name: string) => {
    this.setState({ 
      userId: id,
      users: [],
      termUser: name
    });
  }

  handleAddCampaign = (id: string, name: string) => {
    this.setState({ 
      campaignId: id,
      campaigns: [],
      termCampaign: name
    });
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        title="Add Template"
        onClose={() => this.resetForm()}
        message={this.state.message}
        width={600}
      >
        <div>
          <RowContainer>
            <TextInput
              title="Name"
              type="string"
              placeholder=""
              result={this.state.name}
              onChange={this.onNameChange}
            />
          </RowContainer>
          <RowContainer>
            <TextInput
              title="Description"
              type="string"
              placeholder=""
              result={this.state.description}
              onChange={this.onDescriptionChange}
              multiline
            />
          </RowContainer>
          <RowContainer>
            <SelectInput
              title="Client"
              value={this.state.client}
              values={this.state.clients}
              onChange={this.onClientChange}
            />
          </RowContainer>
          
          <RowContainer>
            <TextInput
              title="User (optional)"
              type="string"
              placeholder="Search users"
              result={this.state.termUser}
              onChange={(event: any) => this.handleUserSearch(event.target.value)}
            />
            {this.state.users.map((user: User, index) => (
              <SearchResultItem id={user.userId} name={`${user.name} - ${user.email}`} onClick={this.handleAddUser} />
            ))}
          </RowContainer>
          <RowContainer>
            <TextInput
              title="Campaign (optional)"
              type="string"
              placeholder="Search campaigns"
              result={this.state.termCampaign}
              onChange={(event: any) => this.handleCampaignSearch(event.target.value)}
            />
            {this.state.campaigns.map((campaign: Campaign, index) => (
              <SearchResultItem id={campaign.id} name={campaign.name} onClick={this.handleAddCampaign} />
            ))}
          </RowContainer>
          <RowContainer>
            <SelectInput
              title="Type (optional)"
              value={this.state.type}
              values={this.state.types}
              onChange={this.onTypeChange}
            />
          </RowContainer>
          <RowContainer>
            <SelectInput
              title="Category (optional)"
              value={this.state.category}
              values={this.state.categories}
              onChange={this.onCategoryChange}
            />
          </RowContainer>
          {/* <RowContainer>
            <TextInput
              title="Rate"
              type="number"
              placeholder=""
              result={this.state.rate}
              onChange={this.onRateChange}
            />
          </RowContainer> */}
          <RowContainer>
            <ActionButton name="Save" onClick={this.handleSave} fullWidth size="sm" disabled={this.state.disabled} />
          </RowContainer>
        </div>
      </Modal>
    )
  }

}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(AddTemplate));



// WEBPACK FOOTER //
// ./src/pages/admin/template/components/AddTemplate.tsx